import ReservationForm from '../../components/ReservationForm/ReservationForm';
import './Reservations.css';

function Reservations() {
  return (
    <div className="reservations-page">
      <div className="page-header">
        <h1>Reservations</h1>
        <div className="section-divider"></div>
        <p className="reservations-page__intro">
          Reserve your table at Cafe Fausse for an unforgettable dining experience.
        </p>
      </div>

      <section className="section">
        <div className="container">
          <div className="reservations-page__form-wrapper">
            <ReservationForm />
          </div>

          <div className="reservations-page__info">
            <div className="reservations-page__info-card">
              <h3>Dining Hours</h3>
              <p>Monday - Saturday: 5:00 PM - 11:00 PM</p>
              <p>Sunday: 5:00 PM - 9:00 PM</p>
            </div>
            <div className="reservations-page__info-card">
              <h3>Contact</h3>
              <p>For special requests or large parties,</p>
              <p>please call us at <a href="tel:+12025554567">(202) 555-4567</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Reservations;
